<template>
  <CurationFooterGallery v-if="parentCuration" :curation="parentCuration" />
</template>

<script lang="ts" setup>
interface Props {
  parentCuration: Curation
  curation: Curation
}
const props = withDefaults(defineProps<Props>(), {})
</script>

<style lang="scss" scoped></style>
